import 'slick-carousel/slick/slick'

export default class PatientStoriesSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-patient-stories-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                appendDots: $('.js-ps-slider-dots'),
                prevArrow: $('.js-ps-slider-previous'),
                nextArrow: $('.js-ps-slider-next'),

                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            arrows: false,
                        }
                    },
                ]
            });
        }

    }

};

new PatientStoriesSlider();